<template>
  <div class="layout">
    <v-layout class="position-relative">
      <v-main>
        <slot></slot>
        <BannerCont />
        <TheFeature />
        <TopOffer />
        <productData :products="flashDeals" />
        <quick />
        <TopCatg />
        <NewProduct :datawoman="tv" />
        <QualtyFeatures />
        <MopilePhone :dataPhone="dataPhone" />
        <FreshVeg :products="freshFood" />
        <LadiesFashion :datawoman="datawoman" />
        <TopElectronics :datawoman="electronics" />
        <AskBanner />
      </v-main>
    </v-layout>
  </div>
</template>
<script setup>
import quick from "@/components/golbal/QuickView.vue";
import BannerCont from "./PageBanner/BannerCont.vue";
import TheFeature from "./PageBanner/TheFeature.vue";
import TopOffer from "./PageBanner/TopOffer.vue";
import productData from "@/components/golbal/ProductsData.vue";
import TopCatg from "./golbal/TopCatg.vue";
import NewProduct from "./golbal/NewProduct.vue";
import QualtyFeatures from "./golbal/QualtyFeatures.vue";
import MopilePhone from "./golbal/MopilePhone.vue";
import FreshVeg from "./FreshVeg.vue";
import LadiesFashion from "./golbal/LadiesFashion.vue";
import TopElectronics from "./golbal/TopElectronics.vue";
import AskBanner from "./PageBanner/AskBanner.vue";
import { phone } from "@/store/PhonesData";
import { products } from "@/store/GetProducts";
import { ladies } from "@/store/LadiesFashion";

import { storeToRefs } from "pinia";
import { onMounted } from "vue";

const prodata = products();
const pho = phone();
const woman = ladies();
const { flashDeals, freshFood } = storeToRefs(prodata);
const { dataPhone } = storeToRefs(pho);
const { datawoman, electronics, tv } = storeToRefs(woman);
onMounted(async () => {
  await prodata.getProducts();
  await pho.getDataPhone();
  await woman.getdataWoman();
});
</script>
